<template>
  <div class="content">
    <div class="container-fluid">

<!--       Dashboard
      <hr> -->
      <!-- Show Checklist -->

      <transition name="fade" v-if="ShowCheckList">

                  <div class="row">

                    <div class="col-md-12">
                      <card>
                        <template slot="header">
                          <p class="text-secondary Hide" style="float: right;" @click="Hide()">HIDE</p>
                          <h5 class="title text-primary">
                            Go Live Check List 
                          </h5>
                          <p class="category">Let's tick off the following to start Checking In visitors. </p>
                        </template>
                        <l-table :data="tableData.data"
                                 :columns="tableData.columns">
                          <template slot="columns"></template>

                          <template slot-scope="{row}">
                            <td>
                              <!-- <base-checkbox v-model="row.checked"></base-checkbox> -->
                              <!-- <i class="nc-icon nc-check-2"></i> -->
                              <!-- <i class="fa fa-check"></i> -->
                              <!-- <i class="fa fa-square-o"></i> -->
                              <i class="fa fa-exclamation"></i>
                             <!-- <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw loading"></i> -->
                            </td>
                            <td>
                               {{row.title}}
                           </td>
                          </template>
                        </l-table>
                      </card>

                    </div>

                  </div>

      </transition>
      

      <!-- Show Dashboard -->

      <div class="row" v-if="ShowDashboard">

            <div class="col-xl-6 col-md-6">
              <div class="row text-center">


                  <template>
                    <div class="Title">
                      <h3>Today's Visitors</h3>
                    </div> 
                  </template>


<!--                 <template v-if="ShowToday">
                  <div class="Today badge rounded-pill Today">Today</div>
                  <div class="ThisWeek badge rounded-pill ThisWeek" @click="Toggle()">This Week</div>
                </template> -->

<!--                 <template v-if="!ShowToday">
                  <div class="Today2 badge rounded-pill" @click="Toggle()">Today</div>
                  <div class="ThisWeek2 badge rounded-pill">This Week</div>
                </template> -->




              </div>
            </div>

            <div class="col-xl-6 col-md-6">
              <div class="row stats text-center">

                <div class="col-3">
                  <h1 class="text-primary stats123">{{Stats.Total}}</h1>
                  <p class="Label">Total Visitors</p>                  
                </div>

                <div class="col-3">
                  <h1 class="text-warning stats123">{{Stats.Pending}}</h1>
                  <p class="Label">Pending Approval</p>                  
                </div>

                <div class="col-3">
                  <h1 class="text-success stats123">{{Stats.CheckedIn}}</h1>
                  <p class="Label">Checked In</p>                  
                </div>

                <div class="col-3">
                  <h1 class="text-danger stats123">{{Stats.CheckedOut}}</h1>
                  <p class="Label">Checked Out</p>                  
                </div>

              </div>
            </div>

          </div>


          <div class="row" v-if="ShowDashboard">

            <div class="col-md-12 table1">

             <card class="strpied-tabled-with-hover">
              <!-- <card class="card-plain"> -->
 <!--                <template slot="header">
                  <h4 class="card-title">Visitors</h4>
                  <p class="card-category">Dislaying {{MyVisitors.length}} visitors</p>
                </template> -->

      
                <div class="table-responsive">

          <div class="col-md-4">

                    <base-input type="text"
                              placeholder="Search Name"
                              v-model="Search"
                              required
                              v-on:keyup="FilterList()"
                              >
                    </base-input>
                     <p class="card-category">Dislaying {{MyVisitors.length}} visitors</p>

                </div>


                    <table class="table table-hover table-sm" id="Visitors">
                      <thead>
                        <slot name="columns">
                          <tr>
                            <th v-for="column in columns">{{column}}</th>
                          </tr>
                        </slot>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in MyVisitors" :key="index">
                          <slot :row="item">

                            <td>{{item.CheckInTime | formatDate}}</td>
                            <td>

                                <div id="visitorPhoto" class="text-center" v-if="item.VisitorPhoto" @click="showPhoto(item);">
                                  <img :src='item.VisitorPhoto' class="userImage">
                                </div>

                                <div id="visitorPhoto" v-if="!item.VisitorPhoto" class="text-center">
                                  <img src="img/default-avatar.png" alt="" class="userImage">
                                </div>
                                  
                            </td>
                            <td>{{item.VisitorFirstName}} {{item.VisitorLastName}}</td>
                            <td>{{item.VisitorMobile}}</td>
                            <td>{{item.VisitorEmail}}</td>
                            <td>{{item.HostLocation}}</td>
                            <td>{{item.HostFirstName}} {{item.HostLastName}}</td>
                            <td class="text-center">
                               <span v-if="item.VisitPurpose">{{item.VisitPurpose}}</span>
                               <span v-if="!item.VisitPurpose"> - </span>
                            </td>
                            <td>
                               <span v-if="item.Type == 'WalkIn'">Walk In</span>
                               <span v-if="!item.Type">Scheduled</span>
                            </td>
                            <td>{{item.CheckInTime | formatDateTime}}</td>
                            <td class="text-center">
                              <span v-if="item.Status == 'CheckedOut'">{{item.CheckOutTime | formatDateTime}}</span>
                              <span v-if="item.Status != 'CheckedOut'">-</span>
                            </td>
                            <td class="text-center">

                              <button v-if="!item.Status" class="btn btn-primary btn-fill" v-on:click="UpdateStatuss(item);">
                                SCHEDULED
                              </button>

                              <button v-if="item.Status == 'CheckedIn'" class="btn btn-success btn-fill" v-on:click="UpdateStatuss(item);">
                                CHECKED IN
                              </button>

                              <button v-if="item.Status == 'CheckedOut'" class="btn btn-danger btn-fill" v-on:click="UpdateStatuss(item);">
                                CHECKED OUT
                              </button>

                              <button v-if="item.Status == 'Pending'" class="btn btn-danger" v-on:click="ApproveVisitor2(item);">
                                PENDING APPROVAL
                              </button>
                         

<!--                               <span v-if="item.Type == 'WalkIn' && item.Status == 'CheckedIn' || item.Status == 'CheckedOut'">Approved On:<br>{{item.ApprovedOn | formatDate}}</span> -->

                            </td>
                            <td>
                              <span v-if="item.ApprovedOn">{{item.ApprovedOn | formatDateTime}}
                              </span>
                            </td>

                          </slot>
                        </tr>
                      </tbody>
                    </table>

                </div>
              </card>

            </div>
    
        </div>

      </div>


      <div class="row">


      </div>


      <div class="row">

        <div class="col-md-8">
<!--           <chart-card :chart-data="lineChart.data"
                      :chart-options="lineChart.options"
                      :responsive-options="lineChart.responsiveOptions">
            <template slot="header">
              <h4 class="card-title">Users Behavior</h4>
              <p class="card-category">24 Hours performance</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Open
                <i class="fa fa-circle text-danger"></i> Click
                <i class="fa fa-circle text-warning"></i> Click Second Time
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated 3 minutes ago
              </div>
            </template>
          </chart-card> -->
        </div>

        <div class="col-md-4">
<!--           <chart-card :chart-data="pieChart.data" chart-type="Pie">
            <template slot="header">
              <h4 class="card-title">Email Statistics</h4>
              <p class="card-category">Last Campaign Performance</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Open
                <i class="fa fa-circle text-danger"></i> Bounce
                <i class="fa fa-circle text-warning"></i> Unsubscribe
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-clock-o"></i> Campaign sent 2 days ago
              </div>
            </template>
          </chart-card> -->
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
<!--           <chart-card
            :chart-data="barChart.data"
            :chart-options="barChart.options"
            :chart-responsive-options="barChart.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">2014 Sales</h4>
              <p class="card-category">All products including Taxes</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Tesla Model S
                <i class="fa fa-circle text-danger"></i> BMW 5 Series
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-check"></i> Data information certified
              </div>
            </template>
          </chart-card> -->
        </div>

        <div class="col-md-6">
          <!-- <card>
            <template slot="header">
              <h5 class="title">Tasks</h5>
              <p class="category">Backend development</p>
            </template>
            <l-table :data="tableData.data"
                     :columns="tableData.columns">
              <template slot="columns"></template>

              <template slot-scope="{row}">
                <td>
                  <base-checkbox v-model="row.checked"></base-checkbox>
                </td>
                <td>{{row.title}}</td>
                <td class="td-actions text-right">
                  <button type="button" class="btn-simple btn btn-xs btn-info" v-tooltip.top-center="editTooltip">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button type="button" class="btn-simple btn btn-xs btn-danger" v-tooltip.top-center="deleteTooltip">
                    <i class="fa fa-times"></i>
                  </button>
                </td>
              </template>
            </l-table>
            <div class="footer">
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated 3 minutes ago
              </div>
            </div>
          </card> -->

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import { globalStore } from '../main.js';
  import { db } from '../main.js';
  import $ from 'jquery';
  import moment from 'moment';
  import axios from 'axios';
  import swal from 'sweetalert';

  // Require needed datatables modules
  require('datatables.net')

  // const tableColumns = ['Id', 'Name', 'Salary', 'Country', 'City']

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        ShowToday: true,
        ShowDashboard: true, 
        ShowCheckList: false,
        CompanyId: '',
        Search: '',
        MyVisitors: [],
        List: [],
        Stats: {
          Total: 0,
          Pending: 0,
          CheckedIn: 0,
          CheckedOut: 0,
        },
        columns: [
          'Date',
          'Photo',
          'Name',
          'Mobile',
          'Email',
          'Location',
          'Host',
          'Purpose',
          'Type',
          'Check In Time',
          'Check Out Time',
          'Status',
          'Approved On'
        ],
        tableData: {
          data: [
            {title: "Download & print your unique QR Code. Visitors will scan this from their phone for web Check In. The best part is they don't need to have the Visity app installed. Go to Side Menu > Profile and download it now.", checked: false},
            {title: "Go to Side Menu > My Team > Add your team members.", checked: false},
            {title: 'To leverage the full power of Visity, check out the "How it works?" section .', checked: false},
          ]
        }
      }
    },
    beforeMount(){
      console.log("beforeMount");
    },
    mounted(){
      console.log("Mounted");

      this.CompanyId = globalStore.AdminId
      console.log("CompanyId: "+this.CompanyId);

      // this.GetMyTeam();
      this.GetToday();

    },
    methods:{
      FilterList(){
        console.log(this.Search);

        var val = this.Search;

        if(!this.Search){
          console.log("Nothing to Search");
          this.MyVisitors = this.List;
        }else{

            var res = this.MyVisitors.filter(item => new RegExp(this.Search, "i").test(item.VisitorName));
            this.MyVisitors = res;

            // // var res = this.MyVisitors.filter(item => {
            // //  console.log(item); 
            // // });

            // var keys = ["VisitorFristName", 'VisitorLastName', 'VisitorMobile', 'HostFirstName', 'HostLastName'];
            // var values = ["John", "Lewis"];

            // var result = this.MyVisitors.filter(function(e) {
            //   return keys.every(function(a) {
            //     return values.includes(e[a])
            //   })
            // })

            // console.log(result);

        }

      },
      Toggle(){

        if(this.ShowToday){
          this.ShowToday = false;
          this.GetThisWeek();
        }else{
          this.ShowToday = true;
          this.GetToday();
        }

      },
      GetToday(){


        console.log("---- Today -----");

        var CurrentDate = moment().format('YYYY-MM-DD');

        var tomorrow = moment().add(1,'days').format('YYYY-MM-DD');
        var yesterday = moment().add(-1,'days').format('YYYY-MM-DD');

        console.log("Today: "+CurrentDate);
        console.log("Tomorrow: "+tomorrow);
        console.log("Yesterday: "+yesterday);

        this.GetMyVisitors(tomorrow, CurrentDate);

      },
      GetThisWeek(){

        // this.MyVisitors = [];

        // var table = $('#Visitors').DataTable();             
        // table.destroy();  

        console.log("---- This Week -----");

        var from =  moment().startOf('isoWeek').format('YYYY-MM-DD');
        var to = moment().endOf('isoWeek').format('YYYY-MM-DD');

        console.log("from: "+from);
        console.log("to: "+to);

        this.GetMyVisitors(to, from);



      },
    GetMyVisitors(to, from){


      // this.destroyDataTable();

      console.log("Getting My Visitors...");

      //-------- call to fetch all data -------
      this.MyVisitors = []
      this.List = []

      console.log("CompanyId: "+this.CompanyId);

      db.collection('MyVisitors')
        .where("HostCompanyId", "==", this.CompanyId)
        .where("CheckInTime", "<", to)
        .where("CheckInTime", ">", from)
        .orderBy('CheckInTime', 'desc')
        .onSnapshot((snap) => {

        // .get()
        // .then((snap) => {

          // this.destroyDataTable();

        this.MyVisitors = [];
        this.List = [];

          // let data = snap.docs;
          // console.log(data);
          snap.docs.forEach(doc => {
            console.log("Doc id is: " + doc.id);
            // console.log("Name is: " + doc.data().FirstName);
            // console.log("Status: " + doc.data().Status);

                    var email = "";

                    if(doc.data().Email){
                      email = doc.data().Email;
                    }


                    this.MyVisitors.push({id: doc.id,
                      VisitorPhoto: doc.data().PhotoURL,
                      VisitorName: doc.data().FirstName+" "+doc.data().LastName,
                      VisitorFirstName: doc.data().FirstName,
                      VisitorLastName: doc.data().LastName,
                      VisitorMobile: doc.data().Mobile,
                      VisitorEmail: email,
                      HostLocation: doc.data().HostLocation,
                      UserId: doc.data().UserId,
                      HostId: doc.data().HostId,
                      Type: doc.data().Type,
                      HostMobile: doc.data().HostMobile,
                      HostFirstName: doc.data().HostFirstName,
                      HostLastName: doc.data().HostLastName,
                      HostCompanyName: doc.data().HostCompanyName,
                      MeetingOn: doc.data().InviteDate+'|'+doc.data().InviteTime,
                      InviteDate: doc.data().InviteDate,
                      InviteTime: doc.data().InviteTime,
                      Status: doc.data().Status,
                      CheckInTime: doc.data().CheckInTime,
                      CheckOutTime: doc.data().CheckOutTime,
                      ApprovedOn: doc.data().ApprovedOn,
                      VisitPurpose: doc.data().VisitPurpose,
                      Date: doc.data().Date,
                      CreatedOn: doc.data().CreatedOn});
                  });

                  this.List = this.MyVisitors;

                  console.log('All data fetch from MyVisitors - Success');

          });

                  setTimeout(()=>{
                    console.log("Total Visitors: "+this.MyVisitors.length);
                    this.CalculateStats();
                    // this.initializeDataTable();
                  },1000)

        // .catch((e) => {
        //   console.log('Error:', (e));
        // });

    },
    CalculateStats(){

        this.Total = 0;
        this.Pending = 0;
        this.countIn = 0;
        this.countOut = 0;

        this.Stats.Total = 0;
        this.Stats.Pending = 0;
        this.Stats.CheckedIn = 0;
        this.Stats.CheckedOut = 0;

      this.MyVisitors.map((val)=>{

        this.Stats.Total++;

        if(val.Status == 'Pending'){
          this.Stats.Pending++;
        }else if(val.Status == 'CheckedIn'){
          this.Stats.CheckedIn++;
        }else if(val.Status == 'CheckedOut'){
          this.Stats.CheckedOut++;
        }

      })

    },
    showPhoto(info){

      console.log('hello');
      // swal.fire({
      //   imageUrl: info.VisitorPhoto,
      //   // imageHeight: 1500,
      //   imageAlt: 'Visity'
      //   });
      },
      Hide(){
        console.log("Hide");
        this.ShowCheckList = false;
        this.ShowDashboard = true;
      },
      GetMyTeam(){

        db.collection("MyTeam")
          .where('CompanyId','==',this.CompanyId)
          .get()
          .then((snap) => {
            console.log("MyTeam Total: "+snap.docs.length)
          })
          .catch((e) => {
            console.log('Error Getting MyTeam:', (e));
          });

      },
    notifyVue (verticalAlign, horizontalAlign, msg, type, icon) {
        // const color = Math.floor((Math.random() * 4) + 1)
        this.$notifications.notify(
          {
            message: msg,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
          })
    }, 
    destroyDataTable(){

        console.log("destroy Data Table");

        this.MyVisitors = [];

        var table = $('#Visitors').DataTable();             
        table.destroy();  

    },
      initializeDataTable(){
        console.log("initializeDataTable");

        setTimeout(() => {
          this.$nextTick(() => {

            $("#Visitors").DataTable({
              // sDom: '<"top"fi>rt<"Bbottom"Bl><"clear">',
              dom: 'frBtip',
              fixedHeader: true,
              buttons: [
                {
                  extend: "csvHtml5",
                  text: "Download",
                  title: "Visitors"
                },
              ]
            });

          });
        }, 2000);


      },   
    UpdateStatuss(info){

      console.log("ChangeStatus")

        swal({
          title: "Are you sure you want to update the status?",
          text: "",
          icon: "warning",
          buttons: true,
          dangerMode: false,
        })
        .then((willDelete) => {
          if (willDelete) {

            console.log("id: "+info.id);
            console.log("Current Status: "+info.Status);

            if(info.Status == 'CheckedIn'){
              this.UpdateToCheckedOut(info.id, info);
            }else{
              this.UpdateToCheckedIn(info.id);
            }


          } else {

          }
        });


    },
    ApproveVisitor2(info){

        swal({
          title: "Are you sure you want to approve visitor?",
          text: "",
          icon: "warning",
          buttons: true,
          dangerMode: false,
        })
        .then((res) => {
          if (res) {

            console.log(JSON.stringify(info, null, 2))

            console.log("id: "+info.id);
            console.log("Current Status: "+info.Status);

            db.collection("MyVisitors")
                  .doc(info.id)
                  .update({Status: "CheckedIn", ApprovedOn: moment().format()})
                  .then(() => {

                    console.log('Success');
                    this.SendPushApprove(info);

                  })
                  .catch(error => {
                    console.error("Error removing document: ", error);
                  });            

          } else {

          }
        });

    },
    UpdateToCheckedOut(id, info){
      console.log("Update Status to CheckedOut");
      console.log("UserId: "+info.UserId);
      console.log("Object: "+JSON.stringify(info, null, 2));
        console.log(globalStore.CompanyName);



            db.collection("MyVisitors")
                  .doc(id)
                  .update({Status: "CheckedOut", CheckOutTime: moment().format()})
                  .then(() => {

                    console.log('Success');
                    // this.SendPush(info)
                    this.SendPushCheckOut(info);

                  })
                  .catch(error => {
                    console.error("Error removing document: ", error);
                  });


    },
    UpdateToCheckedIn(id){
      console.log("Update Status to CheckedIn");

            db.collection("MyVisitors")
                  .doc(id)
                  .update({Status: "CheckedIn"})
                  .then(() => {

                    console.log('Success');
                    location.reload();

                  })
                  .catch(error => {
                    console.error("Error removing document: ", error);
                  });

    },
    SendPushApprove(info){

        console.log("Send Push...");
        console.log("UserId: "+info.UserId);

        db.collection('Users')
          .doc(info.UserId)
          .get()
          .then((doc) => {

            if(doc.exists){
              // console.log(doc.data());
              console.log("Token: "+doc.data().Token);

              console.log("Visitor Name: "+info.VisitorFirstName+"" +info.VisitorLastName);
              console.log("CompanyName: "+globalStore.CompanyName);
              console.log("Check In Time: "+moment(info.CheckInTime).format('h:mm a'));

              var data = {
                Token: doc.data().Token,
                Title: "Access Approved",
                Body: "Welcome to "+globalStore.CompanyName+"",
              };

              console.log("Push Payload: "+JSON.stringify(data, null, 2))

                axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/send-push", data).then((res) => {
                // axios.post("http://localhost:5001/visity-fcbd6/us-central1/widgets", info).then((res) => {
                  console.log(res);
                    // location.reload();
                  
                }).catch((e) => {
                  console.log(e);
                });

            }else{
              console.log("Not Found")
            }
          })
          .catch((e) => {
            console.log('Error:', (e));
          });        

    },
    SendPushCheckOut(info){

        console.log("Send Push...");
        console.log("UserId: "+info.UserId);

        db.collection('Users')
          .doc(info.UserId)
          .get()
          .then((doc) => {

            if(doc.exists){
              // console.log(doc.data());
              console.log("Token: "+doc.data().Token);

              console.log("Visitor Name: "+info.VisitorFirstName+"" +info.VisitorLastName);
              console.log("CompanyName: "+globalStore.CompanyName);
              console.log("Check In Time: "+moment(info.CheckInTime).format('h:mm a'));

              var data = {
                Token: doc.data().Token,
                Title: "Hi "+info.VisitorFirstName,
                Body: "Thank you for visiting "+globalStore.CompanyName+".",
              };

              console.log("Push Payload: "+JSON.stringify(data, null, 2))

                axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/send-push", data).then((res) => {
                // axios.post("http://localhost:5001/visity-fcbd6/us-central1/widgets", info).then((res) => {
                  console.log(res);
                    // location.reload();
                  
                }).catch((e) => {
                  console.log(e);
                });

            }else{
              console.log("Not Found");
            }
          })
          .catch((e) => {
            console.log('Error:', (e));
          });        

    },
    },

  }
</script>

<style scoped="">

  .excelButton{
    background: green;
    border-radius: 10px;
  }

  .stats{
    border: 1px solid #DCDCDC;
    border-radius: 0.5em;
  }

  .Label{
    color: #707070;
  }

  .table1{
    margin-top: 1em;
  }

.dt-buttons.dt-button.buttons-csv.buttons-html5{
  margin-left: 20em;
  background: #00b33c;
  border: 1px solid #00b33c;
  color: #ffffff;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  padding-left: 1em;
  padding-right: 1em;
  border-radius: 0.5em;
}

#Visitors_filter.dataTables_filter{
    /*margin-left: 5em;*/
  }

  .nc-check-2{
    color: green;
  }

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}


.fa-check{
  color: #00b300;
}

.fa-square-o{
  color: #007bff;
}

.fa-exclamation{
  color: red;
}

.btn{
  width: 10em;
  font-size: 1em;
  font-weight: bold;
}

.stats123{
  font-weight: 350;
}


/*Show Todays*/
.Title{
  margin-left: 1em;
  padding-right: 1em;
  padding-left: 1em;
  font-size: 1em;
  font-weight: 400;
}

.Today{
  margin-left: 1em;
  color: #ffffff;
  border: 1px solid #007bff;
  background-color: #007bff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

.ThisWeek{
  margin-left: 1em;
  /*color: #ffffff;*/
  color: #007bff;
  border: 1px solid #007bff;
  background-color: #ffffff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

.ThisWeek:hover{
  cursor: pointer;
  margin-left: 1em;
  color: #ffffff;
  border: 1px solid #007bff;
  background-color: #007bff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}



/*Show This Week*/

.Today2{
  margin-left: 1em;
  color: #007bff;
  border: 1px solid #007bff;
  background-color: #ffffff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

.ThisWeek2{
  margin-left: 1em;
  /*color: #ffffff;*/
  color: #ffffff;
  border: 1px solid #007bff;
  background-color: #007bff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

.Today2:hover{
  cursor: pointer;
  margin-left: 1em;
  color: #ffffff;
  border: 1px solid #007bff;
  background-color: #007bff;
  padding-right: 1em;
  padding-left: 1em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  font-size: 1em;
  font-weight: 400;
  width: 10em;
}

</style>
